import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GetLegacyUsersParams } from '../../user/models/legacy-user.model';
import { FilterData } from '../models/filter-data.model';
import { MigrationResult } from '../models/migrated-user.model';
import {
  LegacyUsersApiService,
  LegacyUserForMigrationDataDto,
  LegacyUserDto,
  MigrateLegacyUserRequest,
  IMigrateLegacyUserRequest,
} from '@core/api/services/legacy-users-api.service';
import { mapFilterDataDto } from '@core/api/mappers/filter-data.mapper';

@Injectable({
  providedIn: 'root'
})
export class LegacyUserService {
  constructor(private readonly legacyUsersApi: LegacyUsersApiService) { }

  /**
   * Retrieves all legacy users from the Biblioteca Documentos database with filter options
   * @param params Query parameters
   */
  getAllLegacyUsers(params: GetLegacyUsersParams): Observable<LegacyUserForMigrationDataDto> {
    const defaults = {
      page: 1,
      pageSize: 50,
      validOnly: false,
      searchText: '',
      libraryLevel: null,
      area: null,
      distrito: null,
      comunidad: null
    };

    const mergedParams = { ...defaults, ...params };

    return this.legacyUsersApi.getAllLegacyUsers(
      mergedParams.validOnly,
      mergedParams.searchText?.trim() || null,
      mergedParams.libraryLevel && mergedParams.libraryLevel !== 'all' ? mergedParams.libraryLevel : null,
      mergedParams.area && mergedParams.area !== 'all' ? mergedParams.area : null,
      mergedParams.distrito && mergedParams.distrito !== 'all' ? mergedParams.distrito : null,
      mergedParams.comunidad && mergedParams.comunidad !== 'all' ? mergedParams.comunidad : null,
      mergedParams.page,
      mergedParams.pageSize,
    );
  }

  /**
   * Retrieves a specific legacy user by email
   * @param email User email address
   */
  getLegacyUserByEmail(email: string): Observable<LegacyUserDto> {
    return this.legacyUsersApi.getLegacyUserByEmail(email);
  }

  getFilterData(): Observable<FilterData> {
    return this.legacyUsersApi.getFilterData().pipe(
      map(dto => mapFilterDataDto(dto))
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  migrateUser(migrationData: any): Observable<MigrationResult> {
    const request = MigrateLegacyUserRequest.fromJS(migrationData);
    return this.legacyUsersApi.migrateUser(request).pipe(
      map(() => ({
        email: migrationData.email,
        keycloakUserId: '',
        migratedAt: new Date().toISOString(),
        success: true,
        assignedRoles: [],
        attributes: {},
        message: 'User migrated successfully',
      } as MigrationResult))
    );
  }
}

